var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossLg = function SvgCrossLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "#DAC599",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 1 19.092 19.092-1.414 1.414L.586 2.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20 20.092.908l1.414 1.414L2.414 21.414z"
  })));
};
export default SvgCrossLg;